<template>
  <div class="survey-card-header">
    <Button v-if="showBackButton" icon @click="$emit('back')">
      <Icon icon="mdi-chevron-left" />
    </Button>
    <span class="survey-card-header__breadcrumb">
      <Typography as="span" variant="body-1">Survey</Typography>
      <span v-if="displayName" class="survey-card-header__breadcrumb-sep"> | </span>
      <Typography
        v-if="displayName"
        as="span"
        variant="subtitle-1"
        class="survey-card-header__breadcrumb-name"
        >{{ displayName }}</Typography
      >
    </span>
  </div>
</template>

<script>
import Button from "@/components/generic/Button.vue";
import Icon from "@/components/generic/Icon.vue";
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "SurveyCardHeader",
  components: { Button, Icon, Typography },
  props: {
    showBackButton: { type: Boolean, default: true },
    displayName: { type: String, default: "" },
  },
};
</script>

<style scoped>
.survey-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  width: 100%;
  align-self: stretch;
}

.survey-card-header__breadcrumb {
  color: rgba(0, 0, 0, 0.87);
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: baseline;
  flex-wrap: nowrap;
}

.survey-card-header__breadcrumb-name {
  margin-left: 0.25em;
}

.survey-card-header__breadcrumb-sep {
  white-space: pre;
}
</style>
